import './theme/tokens.css';

// The web game has been retired from the front door — the root now serves the
// mobile-app marketing site, and `/admin` serves the (claim-gated) admin
// console. The game code remains in src/ui/* but is no longer routed here.
// Both apps are dynamically imported so the admin console is code-split out of
// the public marketing bundle.
const root = document.querySelector<HTMLDivElement>('#app')!;
const path = window.location.pathname;

if (path === '/admin' || path.startsWith('/admin/')) {
  import('./admin/admin-app').then((m) => m.startAdmin(root));
} else if (path === '/play' || path.startsWith('/play/')) {
  // Hidden direct-URL route (not linked from the marketing site) that boots the
  // retired web game for testing. Code-split so it stays out of the public
  // marketing bundle, exactly like /admin. The game routes in-memory, so the
  // /play base path doesn't affect its internal navigation.
  import('./ui/app').then((m) => m.startApp(root));
} else {
  import('./marketing/marketing-app').then((m) => m.startMarketing(root));
}
